import { formatPrismicData } from '@monofront/business/utils';
import { EditorialListAndBubbleProps, IEditorialListAndBubble } from './types';

export const mapEditorialListAndBubble = ({
  prismicContent,
}: {
  prismicContent: EditorialListAndBubbleProps;
}) => {
  const { primary, items }: IEditorialListAndBubble =
    formatPrismicData(prismicContent);

  return {
    primary,
    items,
  };
};
